export const REPORT_CREATE = "createReport";
export const REPORT_DELETE = "deleteReport";
export const REPORT_FINAL_DOWNLOAD = "downloadFinalReport";
export const REPORT_PREVIEW_DOWNLOAD = "downloadReportPreview";
export const REPORT_FETCH_STATE = "fetchReportState";
export const FETCH_REPORTS = "fetchReports";
export const REPORT_UPDATE_LAST_ACTIVE_PATH = "updateLastActiveReportPath";
export const FETCH_ORIGINAL_PLAN_PROVISION = "fetchOriginalPlanProvision";
export const UPDATE_PLAN_PROVISION = "updatePlanProvision";
export const FETCH_AVAILABLE_SELECT_OPTIONS = "fetchAvailableSelectOptions";
export const FETCH_COMPLIANCE_LIMITS = "fetchComplianceLimits";
export const CALC_ANNUAL_COST = "calcAnnualCost";
export const CALC_DC_BALANCES = "calcDcBalances";
export const CALC_DC_CONTRIBUTION = "calcDcContribution";
export const CALC_OTHER = "calcOther";
export const CALC_OUTPUT_FIELDS = "calcOutputFields";
export const CALC_SOCIAL_SECURITY = "calcSocialSecurity";
export const CALC_SOCIAL_SECURITY_TAXABLE = "calcSocialSecurityTaxable";
export const CALC_STATE_RETIREMENT_TAXES = "calcStateRetirementTaxes";
export const CALC_STATE_TAX = "calcStateTax";
export const CALC_INPUT_FIELDS = "calcInputFields";
export const CALC_CONTRIBUTION = "calcContribution";
export const CALC_RESET_STATE = "calcResetState";
export const SAVE_PARTICIPANTS = "saveParticipants";
export const UPDATE_PARTICIPANT = "updateParticipant";
export const DESTROY_PARTICIPANT = "destroyParticipant";
export const DESTROY_ALL_PARTICIPANTS = "destroyAllParticipants";
export const IGNORE_ALL_PARTICIPANTS = "ignoreAllParticipants";
export const CALCULATE_PARTICIPANTS = "calculateParticipants";
export const FETCH_INVALID_PARTICIPANTS = "fetchInvalidParticipants";
export const DOWNLOAD_INVALID_PARTICIPANTS = "downloadInvalidParticipants";
export const UPLOAD_FIXED_PARTICIPANTS = "uploadFixedParticipants";
export const FETCH_COMPENSATION_SEGMENTS = "fetchCompensationSegments";
export const FETCH_ANNUAL_COST_ESTIMATION = "fetchAnnualCostEstimation";
// Steps
export const GO_NEXT_STEP = "goNextStep";
export const GO_PREVIOUS_STEP = "goPreviousStep";
export const GO_STEP = "goStep";
export const RESET_ALTERNATIVE_DESIGNS_STATE = "resetAlternativeDesignState";

export const ALTERNATIVE_DESIGNS_FETCH = "fetchAlternativeDesigns";
export const ALTERNATIVE_DESIGN_UPDATE = "updateAlternativeDesign";
export const ALTERNATIVE_DESIGN_ADD_NEW = "addNewAlternativeDesign";
export const ALTERNATIVE_DESIGN_ARCHIVE = "archiveAlternativeDesign";
export const ALTERNATIVE_DESIGN_UNARCHIVE = "unarchiveAlternativeDesign";
export const ALTERNATIVE_DESIGN_REMOVE = "removeAlternativeDesign";
export const ALTERNATIVE_DESIGNS_REMOVE_ARCHIVED = "removeArchivedAlternativeDesigns";
export const ALTERNATIVE_DESIGNS_CALCULATE_SAVING = "calculateAlternativeDesignsSavingBehavior";

export const ARTICLES_FETCH = "fetchArticles";
export const REPORT_ARTICLE_ADD = "addReportArticle";
export const REPORT_ARTICLE_DESTROY = "destroyReportArticle";
export const REPORT_ARTICLES_FETCH = "fetchReportArticles";

export const AUTH_LOGIN = "authLogin";
export const AUTH_REGISTER = "authRegister";
export const AUTH_LOGOUT = "authLogout";
